// CANONICAL COPY (GH #7115). src/constants/obligations/obl-international-transfer.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-international-transfer',
  title: 'Verify international personal data transfer safeguards',
  description:
    'Confirm that transfers of personal data to a third country or an international organisation take place only where an adequate level of protection is ensured in accordance with GDPR Chapter V. Acceptable transfer mechanisms include an adequacy decision under Article 45, appropriate safeguards under Article 46 (standard contractual clauses, binding corporate rules under Article 47, approved codes of conduct or certification), or — in the absence of those — a specific derogation under Article 49 applied restrictively and documented. Review the transfer register, executed SCCs and BCRs, transfer impact assessments (TIAs) for transfers to countries without adequacy, and supplementary measures where required.',
  category: 'compliance',
  scfIds: ['SCF-PRV-006'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    {
      type: 'ropa-transfers-documented',
      description:
        'At least one processing activity is active in the RoPA register, every active activity records its international transfers, and each one names a GDPR Art. 44–49 transfer basis — an activity with no transfer recorded is not yet evidence',
    },
    {
      type: 'document-published',
      description: 'International transfer procedure and register are published',
    },
    { type: 'document-approved', description: 'Procedure has been approved' },
    { type: 'document-within-sla', description: 'Transfer register review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
